import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb89841"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "styled-table",
  "data-bs-theme": "light"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col col-2" }, "ID | Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Work Center"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Actions")
  ])
], -1))
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "info-message"
}
const _hoisted_9 = {
  key: 1,
  class: "info-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " This task has been successfully concluded. ", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col",
  style: {"border":"0px"}
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "Was the task successful?")
], -1))
const _hoisted_18 = {
  class: "col",
  style: {"border":"0px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Please provide conclusion notes:", -1))

import { useTaskStore } from '@/stores/Tasks';
import { Task } from '@/types/Ops';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { useOpsSupplementStore } from '@/stores/OpsSupplement';
import { computed, ref, watch, onMounted } from 'vue';
import UserBadge from '@/components/UserBadge.vue';
import Button from '@/components/Button.vue';
import Modal from '@/components/Modal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskInline',
  props: {
    task: {},
    taskId: {}
  },
  setup(__props: any) {


const props = __props;
const employeeStore = useEmployeeStore();
const taskStore = useTaskStore();
const opsSupp = useOpsSupplementStore();

const showModal = ref(false);
const notes = ref("");
const showConcludeModal = ref(false);
const isTaskSuccessful = ref(true);
const conclusionNotes = ref("");
const thisTask = computed(() => props.task ?? taskStore.getTaskById(props.taskId));
const wcName = computed(() => {
    const workCenterId = thisTask.value?.work_center?.id;
    const workCenter = workCenterId ? opsSupp.getWorkCenterById(workCenterId) : null;
    return workCenter ? workCenter.name : "None";
});

onMounted(async () => {
    if (!opsSupp.work_centers) {
        await opsSupp.fetch();
    }

});

const employeeState = computed(() => taskStore.taskEmployeeState(thisTask.value?.id ?? 0, employeeStore.currentUser?.id ?? 0));
const otherTaskActive = computed(() => taskStore.current_task && (taskStore.current_task !== thisTask.value?.id));

const canStart = computed(() => {
    const isConcludedSuccessfully = thisTask.value?.successful ?? false;
    return !otherTaskActive.value && !isConcludedSuccessfully && (!employeeState.value || employeeState.value === "CO");
});

const canStop = computed(() => !otherTaskActive.value && (employeeState.value === "ST" || employeeState.value === "RE"));
const canResume = computed(() => !otherTaskActive.value && (employeeState.value === "PA" || employeeState.value === "IN"));
const interruptTask = () => showModal.value = true;

const activeTask = computed(() => {
    const activeTaskId = taskStore.current_task;
    if (activeTaskId) {
        const activeTask = taskStore.getTaskById(activeTaskId);
        return activeTask ? { id: activeTask.id, name: `${activeTask.id} ${activeTask.name}` } : null;
    }
    return null;
});

const truncateDescription = (description) => {
    const maxLength = 50;
    if (description.length > maxLength) {
        return description.substring(0, maxLength) + '...';
    }
    return description;
}


const handleTaskEvent = (eventType, success, notes) => {
    if (thisTask.value) {
        taskStore.addEvent({
            id: 0,
            timestamp: undefined,
            employee: employeeStore.currentUser?.user.id ?? 0,
            task: thisTask.value.id,
            notes: notes,
            event_type: eventType,
            success: success,
        });
        // console.log(`Handling task event: ${eventType}`);
    }
};

const startTask = () => {
    // console.log('Start button clicked');
    handleTaskEvent('ST', true, '');
};

const pauseTask = () => {
    // console.log('Pause button clicked');
    handleTaskEvent('PA', true, '');
    // window.location.reload();
};

const resumeTask = () => {
    // console.log('Resume button clicked');
    handleTaskEvent('RE', true, '');
    // window.location.reload();
};
const concludeTask = () => {
    if (conclusionNotes.value.trim() === '') {
        alert('You must provide conclusion notes.');
        return false;
    }
    handleTaskEvent('CO', isTaskSuccessful.value, conclusionNotes.value);
    showConcludeModal.value = false;
    return true;
};

const doInterrupt = () => {
    if (notes.value.trim() === '') {
        alert('You must provide notes for interruption.');
        return false;
    }
    handleTaskEvent('IN', false, notes.value);
    showModal.value = false;
    return true;
};


watch(() => props.taskId, (newVal) => {
    // Any required logic when taskId changes
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (thisTask.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: '/ops/task/' + thisTask.value.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(thisTask.value.id + " | " +
        thisTask.value.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", null, _toDisplayString(truncateDescription(thisTask.value.description)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", null, _toDisplayString(wcName.value), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (otherTaskActive.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: '/ops/task/' + activeTask.value.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(activeTask.value.name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createTextVNode(" is currently running. To start this task, you must stop the active task. ")
                    ]))
                  : _createCommentVNode("", true),
                (thisTask.value.successful)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true),
                (canStart.value)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 2,
                      onClick: startTask,
                      text: "Start"
                    }))
                  : _createCommentVNode("", true),
                (canStop.value)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 3,
                      onClick: pauseTask,
                      text: "Pause"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_12,
                (canResume.value)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 4,
                      onClick: resumeTask,
                      text: "Resume"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_13,
                (canStop.value)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 5,
                      onClick: interruptTask,
                      text: "Interrupt"
                    }))
                  : _createCommentVNode("", true),
                _hoisted_14,
                _hoisted_15,
                (canStop.value)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 6,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showConcludeModal.value = true)),
                      text: "Conclude"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(Modal, {
                  show: showConcludeModal.value,
                  "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showConcludeModal).value = $event)),
                  title: "Conclude Task",
                  "on-confirm": concludeTask
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isTaskSuccessful).value = $event))
                        }, null, 512), [
                          [_vModelCheckbox, isTaskSuccessful.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((conclusionNotes).value = $event)),
                        placeholder: "Enter conclusion notes here"
                      }, null, 512), [
                        [_vModelText, conclusionNotes.value]
                      ])
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showConcludeModal.value = false))
                    }, "Close"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: concludeTask
                    }, "Confirm")
                  ]),
                  _: 1
                }, 8, ["show"])
              ])
            ])
          ])
        ]),
        _createElementVNode("p", null, [
          _createVNode(Modal, {
            show: showModal.value,
            "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showModal).value = $event)),
            "on-confirm": doInterrupt,
            title: "Enter Notes"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Reason for interruption : "),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((notes).value = $event)),
                placeholder: "Enter reason for Interruption here"
              }, null, 512), [
                [_vModelText, notes.value]
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})